export default "__VITE_ASSET__CMTsCah5__"